/* eslint-disable react/static-property-placement */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { FieldRenderProps } from 'react-final-form-hooks';
import {CmsPageContentIdentifier, CmsPageContentType} from "@/types/av-check";

export interface AppProps {
  innerRef: React.RefObject<HTMLInputElement>
  inputProps?: React.HTMLProps<HTMLInputElement>
  fieldProps: FieldRenderProps
  prefilled: boolean
  suggestions?: string[]
  forceShowSuggestions?: boolean
  onComplete: (name: string, value: string) => void
  onEditting: (name: string) => void
  testElementId: string;
}

export interface AppState {
  activeSuggestion: number
  filteredSuggestions?: string[]
  showSuggestions: boolean
}

const activeSuggestionStyle = { color: '#fff', background: '#005896', padding: '3px 0 3px 10px' };

const autoCompleteStyles = {
  display: 'block',
  width: '100%',
  maxHeight: '150px',
  overflowY: 'auto',
  overflowX: 'hidden',
} as React.CSSProperties;

class Autocomplete extends React.PureComponent<AppProps, AppState> {
  static defaultProps = {
    forceShowSuggestions: false,
  };

  constructor(props: AppProps) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.filterSuggestions = this.filterSuggestions.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.state = {
      activeSuggestion: 0,
      filteredSuggestions: undefined,
      showSuggestions: false,
    };
  }

  componentDidMount() {
    const { prefilled, suggestions } = this.props;
    this.setState({ filteredSuggestions: suggestions });
    if (prefilled) {
      this.setState({ showSuggestions: false });
    } else {
      this.setState({ showSuggestions: true });
    }
  }

  componentDidUpdate(prevProps: AppProps) {
    const { prefilled, suggestions, forceShowSuggestions } = this.props;
    const {
      prefilled: prevPrefilled,
      suggestions: prevSuggestions,
      forceShowSuggestions: prevForceShowSuggestions,
    } = prevProps;
    if (prefilled !== prevPrefilled) {
      this.setState({ showSuggestions: !prefilled });
    }
    if (suggestions !== prevSuggestions) {
      this.setState({ filteredSuggestions: suggestions });
    }
    if (forceShowSuggestions !== prevForceShowSuggestions && forceShowSuggestions) {
      this.setState({ showSuggestions: true });
    }
  }

  onChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { fieldProps, suggestions, onEditting } = this.props;
    const { input } = fieldProps;
    input.onChange(e);
    onEditting(input.name);
    if (suggestions) {
      this.filterSuggestions(e.target.value, suggestions);
    }
  }

  onFocus(e: React.FocusEvent<HTMLInputElement>) {
    const { fieldProps, suggestions } = this.props;
    const { input } = fieldProps;
    input.onFocus(e);
    if (suggestions) {
      this.filterSuggestions(e.target.value, suggestions);
    }
  }
  onBlur(e: React.FocusEvent<HTMLElement>) {
    const relatedTarget = e.relatedTarget as HTMLLIElement;
    if (!relatedTarget || relatedTarget.className !== 'ui-menu-item') {
      this.setState({ showSuggestions: false });
    }
  }

  onClick(e: React.MouseEvent<HTMLElement, MouseEvent>) {
    const { fieldProps, onComplete } = this.props;
    const { input } = fieldProps;
    onComplete(input.name, (e.target as HTMLElement).innerText);
    this.setState({ filteredSuggestions: undefined, showSuggestions: false, activeSuggestion: 0 });
  }

  onKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    const { fieldProps, onComplete } = this.props;
    const { input } = fieldProps;
    const { activeSuggestion, filteredSuggestions, showSuggestions } = this.state;
    if (filteredSuggestions) {
      if (e.keyCode === 13) {
        if (filteredSuggestions && filteredSuggestions.length > 0 && showSuggestions) {
          onComplete(input.name, (filteredSuggestions as any)[activeSuggestion]);
        } else {
          onComplete(input.name, (e.target as HTMLInputElement).value);
        }
        this.setState({ activeSuggestion: 0, showSuggestions: false });
      } else if (e.keyCode === 38) {
        if (activeSuggestion === 0) {
          return;
        }
        this.setState({ activeSuggestion: activeSuggestion - 1 });
      } else if (e.keyCode === 40) {
        if (activeSuggestion + 1 === filteredSuggestions.length) {
          this.setState({ activeSuggestion: 0 });
          return;
        }
        this.setState({ activeSuggestion: activeSuggestion + 1 });
      }
    }
  }

  filterSuggestions(value: string, source: string[]) {
    const reg = new RegExp(`^${value}.*`, 'i');
    const hits = source.filter(
        (suggestion) => suggestion.toLowerCase().match(reg),
    );

    if (hits.length === 1 && value === hits[hits.length - 1]) {
      // There is only one suggestion and it matches the input field value, so hide suggestions
      this.setState({ showSuggestions: false });
    } else {
      // Show suggestions when there is more than one suggestion or the input value doesn't match the single suggestion
      this.setState({ filteredSuggestions: hits, showSuggestions: true, activeSuggestion: 0 });
    }
  }

  render() {
    const {
      innerRef,
      inputProps,
      fieldProps,
      testElementId,
    } = this.props;
    const { input, meta } = fieldProps;

    const { showSuggestions, filteredSuggestions, activeSuggestion } = this.state as any;
    return (
      <>
          <input
            ref={innerRef}
            {...inputProps}
            {...input}
            className="form-control"
            onKeyDown={this.onKeyDown}
            onChange={this.onChange}
            onFocus={this.onFocus}
            data-co-uitest-element={testElementId}
          />
          {
            showSuggestions && filteredSuggestions && filteredSuggestions.length > 0 && (
              <ul className="ui-font ui-menu ui-widget ui-widget-content dropdown-menu" style={autoCompleteStyles}>
                {filteredSuggestions.map((suggestion: any, index: any) => (
                  <li
                    tabIndex={-1}
                    className="ui-menu-item"
                    key={suggestion}
                    onClick={this.onClick}
                    onFocus={() => {}}
                    onMouseOver={() => this.setState({ activeSuggestion: index })}
                    style={index === activeSuggestion ? activeSuggestionStyle : { padding: '3px 0 3px 10px' }}
                  >
                    {suggestion}
                  </li>
                ))}
              </ul>
            )
          }
        {!showSuggestions && meta.error && meta.touched && <span className="help-block">{meta.error}</span>}
      </>
    );
  }
}

const MyComponentRenderFn: React.ForwardRefRenderFunction<HTMLInputElement, AppProps> = (
  // ref is not used because props contains already a custom ref: innerRef.
  // nevertheless ref is kept in args to suppress a react dev warning of lacking of ref argument.
  // this warning should be suppressed since a custom ref is used in this case.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  props, ref,
) => <Autocomplete {...props} />;

export default React.forwardRef(MyComponentRenderFn);
